import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  ClipboardCheck,
  BookOpen,
  FileCheck,
  Award,
  Upload,
} from "lucide-react";
import tokenService from "../../services/token-service";
import SharedDashboardLayout from "./shared-dashboard-layout";
import { useCandidateApplicationStatus } from "../../hooks/use-candidate-application-status";

export function CandidateLayout() {
  const token = tokenService.getToken();
  const loggedInUser = tokenService.getUserDetails();
  const location = useLocation();
  const applications = useCandidateApplicationStatus(token, loggedInUser?._id, location.pathname);

  const isApproved = applications?.status?.toLowerCase() === "approved" || loggedInUser?.dashboardStatus?.value?.toLowerCase() === "approved";

  const rawSidebarLinks = [
    { title: "Dashboard", icon: Home, href: "/emp/dashboard" },
    ...(isApproved ? [{ title: "My Referral Tasks", icon: ClipboardCheck, href: "/emp/tasks" }] : []),
    { title: "Initial Test", icon: ClipboardCheck, href: "/initial-test" },
    { title: "Training", icon: BookOpen, href: "/training" },
    { title: "Final Test", icon: FileCheck, href: "/final-test" },
    { title: "Result", icon: Award, href: "/result" },
    { title: "Upload Documents", icon: Upload, href: "/upload-documents" },
  ];

  const computeLinkState = (title) => {
    let disabled = false;
    let completed = false;

    const initialSubmitted = !!applications?.tests?.initialTest?.submitted || isApproved;
    const trainingCompleted = !!applications?.training?.completed || isApproved;
    const finalSubmitted = !!applications?.tests?.finalTest?.submitted || isApproved;
    const passed = !!applications?.tests?.finalTest?.resultId?.passed || isApproved;

    if (title === "Initial Test") {
      disabled = initialSubmitted;
      completed = initialSubmitted;
    }
    if (title === "Training") {
      // Allow approved users to view training material
      disabled = isApproved ? false : (!initialSubmitted || trainingCompleted);
      completed = trainingCompleted;
    }
    if (title === "Final Test") {
      disabled = !trainingCompleted || finalSubmitted;
      completed = finalSubmitted;
    }
    if (title === "Result") {
      disabled = !finalSubmitted;
      completed = isApproved;
    }
    if (title === "Upload Documents") {
      disabled = isApproved ? true : !passed;
      completed = isApproved;
    }
    if (title === "My Referral Tasks") {
      disabled = false;
      completed = false;
    }

    return { disabled, completed };
  };

  const sidebarLinks = rawSidebarLinks.map((link) => {
    const { disabled, completed } = computeLinkState(link.title);
    return { ...link, disabled, completed };
  });

  return (
    <SharedDashboardLayout 
      sidebarLinks={sidebarLinks}
      defaultRole={isApproved ? "marketing_executive" : "candidate"}
    />
  );
}
